import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid2, TextField, IconButton } from '@mui/material'
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { myApi } from '../../../../config/axiosConfig'
import Swal from 'sweetalert2';
import { Close, Save } from '@mui/icons-material';

function ModalAgregarTipoFormulario({ open, onClose, isEditing = false, selectedTipoFormulario, refresh }) {

    /*=============================================
    DEFINICIÓN DE VALORES INICIALES
    =============================================*/
    const initialValues = {
        nombre_TipoFormulario: selectedTipoFormulario ? selectedTipoFormulario.nombre_TipoFormulario : '',
        id_TipoFormulario: selectedTipoFormulario ? selectedTipoFormulario.id_tipoFormulario : '',
        color: selectedTipoFormulario ? selectedTipoFormulario.color : '',
    };

    /*=============================================
    DEFINICIÓN DE LA VALIDACIÓN DEL FORMULARIO DE TIPOS DE FORMULARIOS
    =============================================*/
    const validationSchema = Yup.object().shape({
        nombre_TipoFormulario: Yup.string().required('Campo obligatorio'),
        color: Yup.string().required('Campo obligatorio'),
    });

    /*=============================================
    FUNCION QUE AGREGA LOS TIPOS DE FORMULARIOS
    =============================================*/
    const handleSubmitForm = async (values) => {
        if (isEditing) {
            const response = await myApi.put('/inspeccion/tiposDeFormularios/updateTiposDeFormularios', values);
            if (response.data.success) {
                onClose()
                Swal.fire({
                    icon: 'success',
                    title: 'Tipo de formulario editado',
                });
                await refresh();
            } else {
                onClose()
                Swal.fire({
                    icon: 'error',
                    title: 'Error al editar tipo de formulario',
                });
            }
        } else {
            const response = await myApi.post('/inspeccion/tiposDeFormularios/insertTiposDeFormularios', values);
            if (response.data.success) {
                onClose()
                Swal.fire({
                    icon: 'success',
                    title: 'Tipo de formulario agregado',
                });
                await refresh();
            } else {
                onClose()
                Swal.fire({
                    icon: 'error',
                    title: 'Error al agregar tipo de formulario',
                });
            }
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {isEditing ? 'Editar Tipo de formulario' : 'Agregar Tipo de formulario'}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>

            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmitForm}>
                {({ values, errors, touched }) => (
                    <Form autoComplete="off">
                        <DialogContent dividers>
                            <Grid2 container spacing={2} direction="column">
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <Field
                                        as={TextField}
                                        name="nombre_TipoFormulario"
                                        label="Nombre de la categoria"
                                        fullWidth
                                        error={touched.nombre_TipoFormulario && Boolean(errors.nombre_TipoFormulario)}
                                        helperText={touched.nombre_TipoFormulario && errors.nombre_TipoFormulario}
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, md: 12 }}>
                                    <Field
                                        as={TextField}
                                        name="color"
                                        label="Color de fondo"
                                        type="color"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={touched.color && Boolean(errors.color)}
                                    />
                                </Grid2>
                            </Grid2>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={onClose} variant="contained" color="primary">
                                Cerrar
                            </Button>
                            <Button type="submit" variant="contained" color="primary" startIcon={<Save />}>
                                Guardar
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}

export default ModalAgregarTipoFormulario